module.exports = {
  createCompany: 'Create Company',
  edit: 'Edit',
  activate: 'Activate',
  deactivate: 'Deactivate',
  cancel: 'Cancel',
  create: 'Create',
  update: 'Update',
  submit: 'Submit',
  pay: 'Pay',
  paid: 'Paid',
  clear: 'Clear',
  selectTime: 'Select time',
  unpaid: 'Unpaid',
  moveItems: 'Move items',
  save: 'Save',
  cancelTransaction: 'Cancel transaction',
  open: 'Open',
  openTable: 'Open table',
  show: 'Show',
  select: 'Select',
  selectTable: 'Select table',
  selectContact: 'Select contact',
  selectDate: 'Select a date',
  selectMethod: 'Select method',
  selectTerminal: 'Select terminal',
  reprint: 'Reprint',
  back: 'Back',
  download: 'Download',
  cancellation: 'Cancellation',
  print: 'Print',
  nullReceipt: 'Null receipt',
  restaurant: 'Restaurant',
  takeaway: 'Take Away',
  collection: 'Collection',
  delivery: 'Delivery',
  createContact: 'Create Contact',
  editContact: 'Edit Contact',
  createAddress: 'Create Address',
  delete: 'Delete',
  close: 'Close',
  deleteContact: 'Delete contact',
  yes: 'Yes',
  no: 'No',
  addItem: 'Add item',
  none: 'None',
  searchContacts: 'Search Contacts',
  processPayment: 'Process payment',
  success: 'Success',
  signatureOk: 'Signature Ok',
  signatureFailed: 'Signature Failed',
  selectPayment: 'Select a payment',
  addPayment: 'Add payment',
  chooseTime: 'Choose time',
  openCashdrawer: 'Open cashdrawer',
  setDefault: 'Set default',
  reregister: 'Reregister',
  proceed: 'Proceed',
  refreshTerminals: 'Refresh terminals',
  generate: 'Generate',
  exportType: 'Select data to be included:',
  backToOrder: 'Back to order',
  noOfPrints: 'No. of prints',
  view: 'View',
  viewAndPrint: 'View and Print',
  isAdded: 'was added to your cart',
  lineOneSearch: 'Enter Line one to Search.',
  clearBasket: 'Clear',
  orderNow: 'Order now',
  refreshBtn: 'Refresh',
  addDiscount: 'Add Discount',
  reload: 'Reload',
  enterPassword: 'Please enter new password',
  newPassword: 'New password',
  confirmPassword: 'Confirm Password',
  register: 'Register',
  forgotPassword: 'Forgot password',
  send: 'Send',
  resetPassword: 'Reset password',
  addAddress: 'Add address',
  checkout: 'Checkout',
  calculate: 'Calculate',
  preorder: 'Preorder',
  click: 'Click',
  goBack: 'to go back',
  here: 'here',
  add: 'Add',
  address: 'address',
  placeOrder: 'Place order',
  order: 'Order',
  remove: 'Remove',
};



// WEBPACK FOOTER //
// ./src/lang/en/actions.js